module.exports = __webpack_public_path__ + "img/kuwait.b68053b7.png";